module.exports = __webpack_public_path__ + "static/img/head.392509e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/head.png
// module id = vu3s
// module chunks = 27